import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { Message, MessageDTO } from '../interfaces/chatbot.interface';
import { environment } from '@environments/environment';

@Injectable({
    providedIn: 'root',
})
export class ChatbotService {
    private readonly httpClient = inject(HttpClient);

    public sendMessage(message: string, sessionId: string, configId: string): Observable<Message> {
        const body: any = {
            text: message,
            sessionId,
            configId,
        };

        const hotjarUserId = this.getHotjarUserId();
        if (hotjarUserId) {
            body.hotjarUserId = hotjarUserId;
        }

        return this.httpClient.post<Message>(environment.api + 'chat', body).pipe(
            map((response: MessageDTO) => ({
                text: response.text,
                role: 'chatbot',
                date: new Date(),
            })),
        );
    }

    public ping(): Observable<void> {
        return this.httpClient.get<void>(environment.api + 'ping');
    }

    private getHotjarUserId(): string | null {
        const cookies = document.cookie.split(';');

        for (const cookie of cookies) {
            const trimmedCookie = cookie.trim();
            if (trimmedCookie.startsWith('_hjSessionUser_')) {
                const value = trimmedCookie.split('=')[1];
                if (value) {
                    try {
                        // Hotjar cookie is base64 encoded JSON
                        const decoded = atob(value);
                        const parsed = JSON.parse(decoded);
                        return parsed.id || null;
                    } catch {
                        // If decoding/parsing fails, return null
                        return null;
                    }
                }
            }
        }
        return null;
    }
}
